<div class="flex items-center justify-between">
    <h1 class="text-2xl">Test Reports Issues</h1>
</div>
<div class="row flex w-full flex-col sm:flex-row mt-4 gap-2">

</div>
<div class=" w-full">
    <byon-report-issue-table></byon-report-issue-table>
</div>